import React, { useEffect } from "react";
import { useTranslation } from "ceco-polyglot";
import { Header } from "../../components/cecoadmin-panel";
import { GeneralInfoTabs } from "../../components/GeneralInfoTabs";
import FullWidthLayout from "../../layout/FullWidthLayout";
import CreateButton from "../../components/CreateButton";

const GeneralInfoPage = (props) => {
  const {
    menuExpanded,
    setMenuExpanded,
    faqsContent,
    privacyContent,
    allCategories,
  } = props;

  const t = useTranslation();
  useEffect(() => {
    document.title = `Recetario Mambo - ${t("title.general-info")}`;
  }, [t]);

  return (
    <FullWidthLayout>
      <Header
        title={t("title.general-info")}
        menuExpanded={menuExpanded}
        setMenuExpanded={setMenuExpanded}
      >
        <CreateButton allCategories={allCategories} />
      </Header>

      <GeneralInfoTabs
        faqsContent={faqsContent}
        privacyContent={privacyContent}
      />
    </FullWidthLayout>
  );
};

export default GeneralInfoPage;
